import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

const FAQS_EN = [
  { q: "I don't have a website — can I still check?", a: "Yes. Type your business name and we check whether AI knows and recommends your brand — website or not." },
  { q: "Is the test really free?", a: "Yes. Enter your business name or website and get your AI visibility score instantly — no signup, no credit card. The full report is delivered free to your WhatsApp." },
  { q: "How is the AI visibility score calculated?", a: "We analyze how often and how prominently your brand is mentioned and cited across major AI platforms like ChatGPT, Gemini, Google AI Overviews, Perplexity, Copilot and Claude, then normalize it into a 0–100 score." },
  { q: "Why do I get the full report on WhatsApp?", a: "WhatsApp is instant, personal, and easy. You get your full breakdown as a message plus a downloadable PDF — and can reply directly if you want help fixing your gaps." },
  { q: "What is AEO?", a: "AEO (Answer Engine Optimization) is the practice of optimizing your brand to be cited and recommended inside AI-generated answers — the natural evolution of SEO for the AI era." },
  { q: "Will you spam me?", a: "No. We send your report and up to 3 short follow-ups. Reply STOP anytime and they end immediately." },
];

const FAQS_HE = [
  { q: "אין לי אתר — אפשר בכל זאת לבדוק?", a: "כן. מקלידים את שם העסק — למשל אופק ביטוחים חולון — ובודקים אם ה-AI מכיר וממליץ עליכם, גם בלי אתר." },
  { q: "הבדיקה באמת בחינם?", a: "כן. מזינים שם עסק או כתובת אתר ומקבלים ציון מיידי — בלי הרשמה, בלי כרטיס אשראי. הדוח המלא נשלח בחינם לוואטסאפ." },
  { q: "איך מחושב ציון נראות ה-AI?", a: "אנחנו בודקים כמה, ובאיזו בולטות, ה-AI מזכיר ומצטט את העסק שלכם בפלטפורמות המובילות — ChatGPT, Gemini, Google AI Overviews, Perplexity, Copilot ו-Claude — ומתרגמים את זה לציון 0–100." },
  { q: "למה הדוח מגיע דווקא בוואטסאפ?", a: "כי וואטסאפ זה מיידי, אישי ופשוט. מקבלים את הפירוט המלא בהודעה + PDF להורדה — ואפשר להשיב ישירות אם רוצים עזרה בתיקונים." },
  { q: "מה זה AEO?", a: "AEO (Answer Engine Optimization) זה לגרום לעסק שלכם להיות מצוטט ומומלץ בתוך התשובות של ה-AI — ההמשך הטבעי של קידום אתרים, בעידן שבו ה-AI עונה במקום גוגל." },
  { q: "תציפו אותי בהודעות?", a: "לא. תקבלו את הדוח ועד 3 הודעות המשך מועילות. משיבים \"הסר\" — וההודעות נפסקות מיד." },
];

const FAQS = HE ? FAQS_HE : FAQS_EN;

export const FAQSection = () => (
  <section id="faq" className="py-20 md:py-28 border-b-2 border-obsidian">
    <div className="av-container max-w-3xl">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-3 w-3 bg-conversion" />
        <span className="av-label text-obsidian">{t("faq.label")}</span>
      </div>
      <h2 className="font-display text-3xl sm:text-4xl text-obsidian mb-10">
        {t("faq.title")}
      </h2>
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {FAQS.map((f) => (
          <AccordionItem key={f.q} value={f.q} className="border-b-2 border-[rgba(10,10,10,0.1)]">
            <AccordionTrigger className={`font-heading text-lg font-bold text-obsidian hover:no-underline py-5 ${HE ? "text-right" : "text-left"}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-neutral-700 text-base leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQSection;
